import {createMessage, decrypt, encrypt, readMessage} from 'openpgp';

class Crypto {
    public static async encrypt(message: string, secret: string) {
        return await encrypt({
            message: await createMessage({text: message}),
            passwords: [secret]
        });
    }

    public static async decrypt(encryptedMessage: string, secret: string) {
        return decrypt({
            message: await readMessage({armoredMessage: encryptedMessage}),
            passwords: [secret]
        });
    }

    public static randomString = (length: number = 32): string => {
        let text = '';
        const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < length; i++) {
            text += possibleChars.charAt(Crypto.randomInt(possibleChars.length-1));
        }
        return text;
    };

    private static randomInt = (max: number): number => {
        return Math.floor(Math.random() * 1000000) % (max+1);
    };
}

export default Crypto;